<div id="layout-wrapper">

    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
    </app-topbar>
    @if(claims.orgRoleId == 3){<app-sidebar></app-sidebar>}
    <div class="main-content" id="mainContent">
        <div class="bulk-upload-default"
            *ngIf="hasEverUsedDragDrop && claims.IsFinanceManager && !isScanInProgress && !isImportInProgress && !isDragDropDisabledOnCurrentRoute">
            <img src="../../assets/svg-icons/icons/upload-cloud.svg" alt="">
            <p>Drag & Drop Credit Card Statement anywhere on the screen</p>
        </div>
        <div class="page-content"
            [class.py-0]="!(routeIsActive('/settings') || isRoot() || routeIsActive('/openapi') || routeIsActive('/self-setup') || routeIsActive('/setupyourorganisation') || routeIsActive('/deletedata') || routeIsActive('/preapproval') || routeIsActive('/disappearingExpenses') || routeIsActive('/advances') || routeIsActive('/carbonFPrint') || routeIsActive('/dashboard/overview')  || routeIsActive('/fxRateSetup') || routeIsActive('/universalimport/uploadNewfile') || routeIsActive('/universalimport/defineNewheader') || routeIsActive('/universalimport/fxnewratereview') || routeIsActive('/universalimport/importnewsummary') || routeIsActive('/universalimport/importnewmapping') || routeIsActive('/universalimport/importEffectiveNewDate'))">
            <div class="container-fluid">
                <!-- content -->
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
<app-rightsidebar></app-rightsidebar>